import { render } from "./stablishPassword.vue?vue&type=template&id=608e370c"
import script from "./stablishPassword.vue?vue&type=script&lang=js"
export * from "./stablishPassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__